import React, { createContext, useContext, useState, useEffect } from 'react';
import { ThemeType, ThemeColors, themes } from '../styles/themes';

interface ThemeContextType {
  currentTheme: ThemeType;
  colors: ThemeColors;
  setTheme: (theme: ThemeType) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState<ThemeType>(() => {
    const savedTheme = localStorage.getItem('theme') as ThemeType;
    return savedTheme || 'dark';
  });

  useEffect(() => {
    localStorage.setItem('theme', currentTheme);
    // Apply theme classes to body
    document.body.className = `theme-${currentTheme}`;
    document.body.style.backgroundColor = themes[currentTheme].background.default;
  }, [currentTheme]);

  const value = {
    currentTheme,
    colors: themes[currentTheme],
    setTheme: setCurrentTheme,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}; 